<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <el-form ref="searchForm" :inline="true" :model="searchForm">
                        <el-form-item label="应用版本" prop="applyVersion">
                            <el-input v-model="searchForm.applyVersion" placeholder="应用版本" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="mini" @click="common.page = 1;getData()">
                                搜索
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" @click="createVersion()" v-if="isShow">创建新版本</el-button>
                </div>
            </div>

            <el-table :data="data" style="width: 100%;margin-bottom: 20px;" 
                v-loading="loading"
                :element-loading-text="loadingText" 
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)" 
                row-key="id" border default-expand-all>

                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="applyVersion" label="应用版本" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus == 2">
                            {{ scope.row.applyVersion }}<span style="color:red;">(此版本正在用)</span>
                        </div>
                        <div v-else>
                            {{ scope.row.applyVersion }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="更新功能" prop="remark" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.remark }}
                    </template>
                </el-table-column>
                <el-table-column label="升级范围"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.rangeSet == 1">
                            全部学校
                        </div>
                        <div v-else-if="scope.row.rangeValue !='' && scope.row.rangeValue !=null">
                            部分学校（{{ scope.row.rangeValue }}）
                        </div>
                        <div v-else>
                            部分学校
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gmtCreate"  label="发布时间" show-overflow-tooltip width="150px;"></el-table-column>
                <el-table-column prop="" label="下架时间" width="140">
                    <template slot-scope="scope">
                        <div v-if="scope.row.gmtModified != '' && scope.row.gmtModified != null">
                            {{ scope.row.gmtModified }}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.applyStatus == 1">
                            <el-button @click.native.prevent="releaseVersion(scope.row.id, 2)" type="text">
                                发布
                            </el-button>
                            <el-button @click.native.prevent="del(scope.row.id)" style="margin-top:5px;" type="text">
                                删除
                            </el-button>
                        </span>
                        <span v-else-if="scope.row.applyStatus == 3">
                            <el-button @click.native.prevent="rollBackVersion(scope.row.id, 2)" type="text">
                                回滚到此版本
                            </el-button>
                        </span>
                        <span v-else-if="scope.row.applyStatus == 2">
                            <el-button type="text" @click.native.prevent="offApply(scope.row.id)"
                                v-if="isShow">下架</el-button>
                        </span>
                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleApplySet"
                                    icon="el-icon-circle-check">应用设置</el-dropdown-item>
                                <el-dropdown-item command="handleRangeSet"
                                    icon="el-icon-circle-check">升级范围设置</el-dropdown-item>
                                <el-dropdown-item command="handleUpgradeRecord"
                                    icon="el-icon-circle-check">升级记录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="common.page" :page-size="common.pageSize" :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper" :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 创建新版本弹出框 -->
        <create-version-form v-model="createVersionFormVisible" :uploadFilesUrl="uploadFilesUrl" @submit="getData" />
        <!-- 应用设置-->
        <apply-set v-model="applySetVisible" :applyId="applyId" :isShow="isShow" />
        <!-- 升级范围设置-->
        <range-set v-model="rangeSetVisible" :applyManage="applyManage" :isShow="isShow" />
        <!-- 应用升级记录-->
        <upgrade-record v-model="upgradeRecordVisible" :applyManage="applyManage" :isShow="isShow" />
    </div>
</template>

<script>
import http from '../../../../common/http'
import createVersionForm from "./components/createVersionForm.vue";
import applySet from "./components/applySet.vue";
import rangeSet from "./components/rangeSet.vue";
import upgradeRecord from "./components/upgradeRecord.vue";

export default {
    name: "ThirdApplyManage",
    data() {
        return {
            menuName: "",
            loading:false,
            loadingText:"",
            createVersionFormVisible: false,
            applySetVisible:false,
            rangeSetVisible:false,
            upgradeRecordVisible:false,
            isShow: true,
            common: {
                total: 0,            //总数据量
                pageSize: 30,        //每页条数
                page: 1,              //页码
                isPage: 1,            //是否分页
                allSizes: [30, 50, 100], //每页条数筛选
                checkboxArr: []       //多选框数组
            },
            searchForm: {
                applyVersion: "",
            },
            form: {
                id: "",
                applyStatus: ""
            },
            // 传递的参数
            uploadFilesUrl: "",
            applyId:"",
            depts: [],
            data: [],
            applyManage: {}
        }
    },
    created: function () {
        this.menuName = sessionStorage.getItem("selectMenuItem_key")
        // 用户信息
        let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
        // 如果id为1的话，表示管理员，管理才能上传或者回滚此应用及拷贝
        if (userinfo.id == 1) {
            this.isShow = true
        } else {
            this.isShow = false
        }
        this.uploadFilesUrl = this.thirdApplyManageCreateVersionUrl
        this.getData()
    },
    components: {
        createVersionForm, applySet, rangeSet, upgradeRecord
    },
    methods: {
        indexMethod(index) {
            return (this.common.page - 1) * this.common.pageSize + (index + 1);
        },
        getData() {
            this.loading=true
            this.loadingText="数据加载中..."

            let url = this.thirdApplyManageListUrl;
            let data = {
                isPage: this.common.isPage,
                page: this.common.page,
                limit: this.common.pageSize,
                type: 1, // 应用类型（1-桌面应用，2-Android应用，3-苹果应用）
                applyVersion: this.searchForm.applyVersion
            };
            // console.log(JSON.stringify(data))
            // return;
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.data = res.data.list;
                    this.common.total = res.data.total;

                    // 不是管理员进来，只能看到一条已发布的数据
                    if (!this.isShow) {
                        let release = []
                        for (let i = 0; i < this.data.length; i++) {
                            let v = this.data[i]
                            if (v.applyStatus == 2) {
                                release.push(v)
                            }
                        }
                        this.data = release
                        this.common.total =1
                    }

                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
                this.loading=false
            }, (err) => {
                this.loading=false
            });
        },
        handleSizeChange(val) {
            this.common.pageSize = val;
            this.common.page = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.common.page = val;
            this.getData();
        },
        // 创建新版本
        createVersion() {
            this.createVersionFormVisible = true
        },
        //删除
        del(id) {
            this.searchForm.id = id;
            this.$commonFn.showConfirm(this.delSuccess);
        },
        delSuccess() {
            let url = this.thirdApplyManageDeleteApplyUrl;
            let data = {
                id: this.searchForm.id
            };
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.common.page = 1;
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            })
        },
        releaseVersion(id, applyStatus) {
            let msg = "发布此版本，将覆盖正在使用的版本，是否继续？";
            this.form.id = id;
            this.form.applyStatus = applyStatus;
            this.$commonFn.showConfirm2(msg, this.updateSuccess);
        },
        rollBackVersion(id, applyStatus) {
            let msg = "回滚此版本，将覆盖正在使用的版本，是否继续？";
            this.form.id = id;
            this.form.applyStatus = applyStatus;
            this.$commonFn.showConfirm2(msg, this.updateSuccess);
        },
        updateSuccess() {
            let url = this.thirdApplyManageUpdateApplyStatusUrl;
            let data = {
                id: this.form.id,
                applyStatus: this.form.applyStatus
            };
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.common.page = 1;
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            })
        },
        offApply(id) {
            let msg = "确定下架此版本吗？";
            this.form.id = id;
            this.$commonFn.showConfirm2(msg, this.offApplySuccess);
        },
        offApplySuccess() {
            let url = this.thirdApplyManageOffUrl;
            let data = {
                id: this.form.id,
            };
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.common.page = 1;
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            })
        },
        // 更多操作触发
        handleCommand(command, row) {
            switch (command) {
                case "handleApplySet":
                    this.applySet(row);
                    break;
                case "handleRangeSet":
                    this.rangeSet(row);
                    break;
                case "handleUpgradeRecord":
                    this.upgradeRecord(row);
                    break;
                default:
                    break;
            }
        },
        // 应用设置
        applySet(row) {
            console.log('应用设置')
            this.applySetVisible = true
            this.applyId = row.id

        },
        // 升级范围设置
        rangeSet(row) {
            console.log("升级范围设置")
            this.rangeSetVisible = true
            this.applyManage = row
        },
        // 升级记录
        upgradeRecord(row){
            console.log("升级记录")
            this.upgradeRecordVisible = true
            this.applyManage = row
        }

    },
    mixins: [http]
}

</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/page/apply/thirdApply/index.vue